export default __webpack_public_path__ + "static/media/starbucks.ac7f94a5.png";